export interface TipFaq {
  q: string;
  a: string;
}

export const TIP_FAQS: TipFaq[] = [
  {
    q: '在寻料站提供线索，会不会暴露我的身份？',
    a: '不会。提交时称呼与邮箱均可选填；线索内容会经脱敏处理后再进入核实环节，我们不会对外公开你的账号、昵称或联系方式，采用“只认线索、不认人”的处理原则。',
  },
  {
    q: '想找的“瓜”或线索还没有对应征集令，能不能求料？',
    a: '可以。你可以在“提供线索”表单里选择“求料”类型，写下你希望找到的信息、时间范围和已有线索，我们会据此生成新的征集令并公开寻料，你也可以围观别人如何补充与求证。',
  },
  {
    q: '征集令里的线索达到多少会被采纳？',
    a: '不以数量为唯一标准，我们会综合线索完整度、信源可核验程度以及能否补充关键截图或文件来判断；同一指向的多条独立线索相互印证时，会优先进入深度核实。',
  },
  {
    q: '我能匿名补充截图、录音或文件证据吗？',
    a: '可以。你可在表单中注明证据类型与来源方式，我们会单独与你沟通安全、合规的上传渠道；涉及隐私或敏感内容的材料，未经你同意不会进入公开页面。',
  },
  {
    q: '一次只能针对一个征集令提交吗？可以撤销吗？',
    a: '一次提交建议聚焦一个征集令，便于归类核实；如果你手头有多条线索，可分多次提交。提交后如需撤回，可在收到回执后凭编号联系我们说明。',
  },
  {
    q: '提交之后多久有反馈？在哪里查看核实进度？',
    a: '一般 24 到 72 小时内会通过你预留的联系方式给出初步回执；进入核实流程的线索会在对应征集令的“求证工作台”更新状态，你也能围观其他线索的扫核过程。',
  },
];